import { trackEvent } from '../utils/analytics';

export function logEvent(type, metadata = {}) {
  try { trackEvent(type, metadata); } catch (_e) {}
}


